import { render, staticRenderFns } from "./WowzaTargetConfig.vue?vue&type=template&id=a086a124&scoped=true"
import script from "./WowzaTargetConfig.vue?vue&type=script&lang=js"
export * from "./WowzaTargetConfig.vue?vue&type=script&lang=js"
import style0 from "./WowzaTargetConfig.vue?vue&type=style&index=0&id=a086a124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a086a124",
  null
  
)

export default component.exports